import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M7.46114178,7.30932709 L10.5159169,7.30932709 C11.0678757,7.30932709 11.4253673,7.89202095 11.1752942,8.38407985 L9.03499176,12.5954682 C8.84991711,12.9596323 8.40467116,13.1048129 8.0405071,12.9197383 C7.67634304,12.7346636 7.53116238,12.2894177 7.71623704,11.9252536 L9.31033103,8.78861801 L6.25555595,8.78861801 C5.70359716,8.78861801 5.3461055,8.20592415 5.59617859,7.71386525 L7.78625849,3.40453179 C7.97133315,3.04036773 8.4165791,2.89518708 8.78074316,3.08026173 C9.14490722,3.26533638 9.29008787,3.71058233 9.10501322,4.07474639 L7.46114178,7.30932709 Z"/>
  </svg>
);
